import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TeamItemComponent } from './team-item.component';
import { TeamProfileImageComponent } from '../../_shared/components/team-profile-image/team-profile-image.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TeamProfileImageComponent
    ],
    declarations: [
        TeamItemComponent
    ],
    exports: [
        TeamItemComponent
    ]
})
export class TeamItemComponentModule { }
